import "@hotwired/turbo-rails"
import { usersMutate } from "./UsersMutate";
import { mobileMenu } from "./MobileMenu";
import { dropdown } from "./Dropdown";
import { fulfilledRidesChart } from "./FulfilledRidesChart";
import { organizationRequestsChart } from "./OrganizationRequestsChart";
import { driverActivityChart } from "./DriverActivityChart";
import { reportFilters } from "./ReportFilters";
import { infoPopup } from "./InfoPopup";
import { adminRideRequestMutate } from "./AdminRideRequestMutate";
import { richTextEditor } from "./RichTextEditor";
import { copyLoginLink } from "./CopyLoginLink";

window.usersMutate = usersMutate;
window.mobileMenu = mobileMenu;
window.dropdown = dropdown;
window.fulfilledRidesChart = fulfilledRidesChart;
window.organizationRequestsChart = organizationRequestsChart;
window.driverActivityChart = driverActivityChart;
window.reportFilters = reportFilters;
window.infoPopup = infoPopup;
window.adminRideRequestMutate = adminRideRequestMutate;
window.richTextEditor = richTextEditor;
window.copyLoginLink = copyLoginLink;
